import React, { FC, ReactElement } from 'react'

import * as Styled from './styles/ListItem.style'

import { ListItemProps } from './ListItem.types'

const ListItem: FC<ListItemProps> = ({
  className,
  role,
  children,
  onClick,
  onMouseDown,
  onMouseUp,
  onTouchStart,
  onTouchEnd,
  href,
  customRouterProps,
  id,
  onMouseEnter,
  onMouseLeave,
  srText,
  htmlAttributes,
  interactionRef,
  disabled = false,
  listType = 'unordered',
  listStyle = 'none',
}: ListItemProps): ReactElement => {
  return (
    <Styled.ListItem
      id={id}
      className={className}
      role={role}
      aria-disabled={disabled && !!onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      listType={listType}
      listStyle={listStyle}
    >
      <Choose>
        <When condition={onClick || href || customRouterProps}>
          <Styled.InteractionListItem
            onClick={onClick}
            href={href}
            customRouterProps={customRouterProps}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            label={srText}
            domRef={interactionRef}
            disabled={disabled}
            {...htmlAttributes}
          >
            {children}
          </Styled.InteractionListItem>
        </When>
        <Otherwise>{children}</Otherwise>
      </Choose>
    </Styled.ListItem>
  )
}

export default ListItem
